import { render, staticRenderFns } from "./TheOrderDialog.vue?vue&type=template&id=673147d5&scoped=true&"
import script from "./TheOrderDialog.vue?vue&type=script&lang=js&"
export * from "./TheOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./TheOrderDialog.vue?vue&type=style&index=0&id=673147d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673147d5",
  null
  
)

export default component.exports